'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');let

ElementService=function(_BaseService){_inherits(ElementService,_BaseService);
function ElementService(){_classCallCheck(this,ElementService);return _possibleConstructorReturn(this,
_BaseService.call(this));
}ElementService.prototype.

selectElement=function selectElement(selector){
if(selector instanceof Object&&Object.getPrototypeOf(selector)===this._ngElementPrototype){
return selector;
}

return angular.element(selector);
};ElementService.prototype.

setText=function setText(selector,text){
return this.selectElement(selector).text(text);
};ElementService.prototype.

removeClass=function removeClass(selector,classToRemove){
return this.selectElement(selector).removeClass(classToRemove);
};ElementService.prototype.

removeAttr=function removeAttr(selector,attrToRemove){
return this.selectElement(selector).removeAttr(attrToRemove);
};ElementService.prototype.

addClass=function addClass(selector,classToAdd){
return this.selectElement(selector).addClass(classToAdd);
};ElementService.prototype.

hasClass=function hasClass(selector,classToCheck){
return this.selectElement(selector).hasClass(classToCheck);
};ElementService.prototype.

hasAnyClass=function hasAnyClass(selector,classesToCheck){
const classList=this.classList(selector);
if(classList.length===0){
return!1;
}

const classListSet=new Set(classList);
return _.some(classesToCheck,function(cl){return classListSet.has(cl)});
};ElementService.prototype.

classList=function classList(selector){
return _.toArray(this.selectElement(selector).prop('classList'));
};ElementService.prototype.

setAttributeIfNew=function setAttributeIfNew(selector,attr,value){
const el=this.selectElement(selector);
if(el.attr(attr)===value){
return;
}

return el.attr(attr,value);
};_createClass(ElementService,[{key:'_ngElementPrototype',get:function()

{
return this.__ngElementPrototype||(this.__ngElementPrototype=Object.getPrototypeOf(angular.element(document.createDocumentFragment('div'))));
}}]);return ElementService}(BaseService);


module.exports=ElementService;
//# sourceMappingURL=elementService.js.map
